<!-- Page banner Area -->
<div class="page-banner bg-5">
    <div class="d-table">
        <div class="d-table-cell">
            <div class="track-page-shell">
                <div class="page-content track-banner-content">
                    <div class="w-100 mx-auto bg-white shadow-lg rounded-4 p-3 p-md-4" style="max-width: 760px;">
                        <div
                            class="d-flex align-items-center justify-content-between mb-3 flex-wrap gap-2 pb-2 border-bottom">
                            <div class="d-flex align-items-center gap-2">
                                <i class="fas fa-truck-fast text-primary fs-5"></i>
                                <span class="fw-bold text-dark fs-6">Track Your Order</span>
                            </div>
                            <a routerLink="/contact"
                                class="btn btn-outline-primary btn-sm rounded-pill px-3 py-1.5 d-inline-flex align-items-center gap-2 text-decoration-none contact-header-btn">
                                <i class="fas fa-headset"></i>
                                <span class="fw-semibold">Contact Us</span>
                            </a>
                        </div>
                        <form class="d-flex flex-column flex-md-row align-items-center gap-2 w-100 track-search-form"
                            (ngSubmit)="getOrderTrackingDetails(trackingInput.value)">
                            <div class="track-select-wrapper">
                                <mat-form-field appearance="outline" subscriptSizing="dynamic"
                                    class="w-100 track-search-mat-field">
                                    <mat-select [value]="'tracking_number'"
                                        (selectionChange)="onSelectNumber($event.value)">

                                        <mat-option value="tracking_number">
                                            Tracking Number
                                        </mat-option>

                                        <mat-option value="order_number">
                                            Order Number
                                        </mat-option>

                                    </mat-select>
                                </mat-form-field>
                            </div>
                            <div class="track-input-wrapper">
                                <input type="text" name="search" [placeholder]="placeholder"
                                    class="form-control track-search-input" #trackingInput>
                            </div>
                            <div class="track-btn-wrapper">
                                <button type="submit" name="submit" class="btn btn-dark track-search-btn">
                                    <i class="fas fa-search"></i>
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- End Page banner Area -->

<!-- DEFAULT STATE: Horizontal Smooth Auto-Scrolling Product Marquee when page opens -->
<div *ngIf="!hasOrderDetails && !noOrderFound && scrapedProducts.length > 0" class="track-default-products py-4">
    <div class="track-page-shell">
        <!-- Horizontal Marquee Container -->
        <div class="track-promo-marquee-horizontal">
            <div class="track-promo-track-horizontal" [class.track-promo-scroll-infinite]="marqueeProducts.length > 1">
                <a *ngFor="let product of marqueeProducts" class="track-promo-item-horizontal" [href]="product.url"
                    target="_blank" rel="noopener noreferrer">
                    <div class="track-promo-item__brand">
                        <img [src]="this.njourImageUrl || 'assets/img/njour-logo.png'" alt="Njour Logo"
                            class="track-promo-item__brand-logo">
                    </div>
                    <div class="track-promo-item__visual" *ngIf="product.imageUrl">
                        <img [src]="product.imageUrl" [alt]="product.title" class="track-promo-item__image">
                    </div>
                    <div class="track-promo-item__content">
                        <div class="track-promo-item__meta">
                            <span class="track-promo-item__taxonomy">{{ product.taxonomy_title }}</span>
                        </div>
                        <h3 class="track-promo-item__title">{{ product.title }}</h3>
                        <div class="track-promo-item__stats" *ngIf="product.sales || product.stock > 0">
                            <span class="track-promo-item__sales" *ngIf="product.sales">{{ product.sales }}</span>
                            <span class="track-promo-item__stock" *ngIf="product.stock > 0">Stock: {{ product.stock
                                }}</span>
                        </div>
                        <div class="track-promo-item__bottom">
                            <div class="track-promo-item__pricing">
                                <span class="track-promo-item__price">{{ product.price }}</span>
                                <span class="track-promo-item__mrp" *ngIf="product.originalPrice">{{
                                    product.originalPrice }}</span>
                                <span class="track-promo-item__discount" *ngIf="product.discount">{{ product.discount
                                    }}</span>
                            </div>
                            <div class="track-promo-item__cta">
                                <span class="track-promo-stars"
                                    [attr.aria-label]="(product.rating | number:'1.1-1') + ' out of 5 stars'">
                                    <span class="track-promo-stars__base">★★★★★</span>
                                    <span class="track-promo-stars__fill"
                                        [style.width.%]="getRatingWidth(product.rating)">★★★★★</span>
                                </span>
                                <span class="track-promo-item__rating">{{ product.rating | number:'1.1-1' }}</span>
                            </div>
                        </div>
                    </div>
                </a>
            </div>
        </div>
    </div>
</div>

<div *ngIf="hasOrderDetails">
    <div class="track-page-shell track-summary-wrap" style="margin-bottom: 0px;">
        <div class="track-summary-layout" [class.track-layout-centered]="scrapedProducts.length === 0">
            <article class="card track-summary-card">
                <header class="card-header track-summary-header">
                    <div class="d-flex align-items-center justify-content-between flex-wrap gap-3">
                        <div>
                            <div class="track-summary-kicker">Order Tracking</div>
                            <div class="track-summary-title">My Orders / Tracking</div>
                        </div>
                        <div class="track-summary-badge">
                            <span>Live Tracking</span>
                        </div>
                    </div>
                </header>
                <div class="card-body track-summary-body">
                    <div class="row g-3 align-items-stretch">
                        <div class="col-lg-8">
                            <div class="track-overview-panel h-100">
                                <div class="track-topline">
                                    <div class="track-topline-item">
                                        <span class="track-label">Order Number</span>
                                        <h6 class="mb-0">{{ OrderDetails?.order_number }}</h6>
                                    </div>
                                    <div class="track-topline-item text-md-end">
                                        <span class="track-label">Tracking Number</span>
                                        <h6 class="mb-0 track-number-text">{{ OrderDetails?.tracking_number }}</h6>
                                    </div>
                                </div>

                                <div class="row g-3 track-info-grid">
                                    <div class="col-md-6 col-xl-4">
                                        <div class="track-info-item track-info-card-alt">
                                            <span class="track-label">Customer Name</span>
                                            <div class="track-info-value">{{ OrderDetails?.buyer_name ?
                                                OrderDetails?.buyer_name : 'N/A' }}</div>
                                        </div>
                                    </div>
                                    <div class="col-md-6 col-xl-4">
                                        <div class="track-info-item track-info-card-alt">
                                            <span class="track-label">Shipping BY</span>
                                            <div class="track-info-value">{{ OrderDetails?.carrier_name || 'N/A' }}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-6 col-xl-4">
                                        <div class="track-info-item track-info-card-alt">
                                            <span class="track-label">Tracking #</span>
                                            <div class="track-info-value">
                                                <span>
                                                    <ng-container *ngIf="
        OrderDetails?.carrier_tracking_number &&
        OrderDetails?.carrier_name;
        else noCarrierTracking
    ">
                                                        <!-- Bombino -->
                                                        <ng-container *ngIf="OrderDetails?.carrier_name === 'Bombino'">
                                                            <a class="track-link" href="https://www.bombinoexp.ae/"
                                                                target="_blank" rel="noopener noreferrer">
                                                                {{ OrderDetails?.carrier_tracking_number }}
                                                                <i class="bx bxs-hand-up track-link-icon"></i>
                                                            </a>
                                                        </ng-container>

                                                        <!-- Tirupati -->
                                                        <ng-container *ngIf="OrderDetails?.carrier_name === 'Tirupati'">
                                                            <a class="track-link" [href]="
                'http://shreetirupaticourier.net/Frm_DocTrack.aspx?docno=' +
                OrderDetails?.carrier_tracking_number
            " target="_blank" rel="noopener noreferrer">
                                                                {{ OrderDetails?.carrier_tracking_number }}
                                                                <i class="bx bxs-hand-up track-link-icon"></i>
                                                            </a>
                                                        </ng-container>

                                                        <!-- Other Couriers -->
                                                        <ng-container *ngIf="
            OrderDetails?.carrier_name !== 'Tirupati' &&
            OrderDetails?.carrier_name !== 'Bombino' &&
            OrderDetails?.carrier_name !== ''
        ">
                                                            <a class="track-link">
                                                                {{ OrderDetails?.carrier_tracking_number }}
                                                            </a>
                                                        </ng-container>
                                                    </ng-container>
                                                    <ng-template #noCarrierTracking>
                                                        <div>{{ OrderDetails?.carrier_tracking_number || 'N/A' }}</div>
                                                    </ng-template>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-12" *ngIf="canUpdateTracking">
                                        <button type="button" class="btn btn-outline-primary btn-sm rounded-pill px-4"
                                            (click)="openUpdateTrackingModal()">
                                            <i class="fas fa-pen me-2"></i>Update Tracking
                                        </button>
                                    </div>
                                </div>

                                <div class="tracking_details_content tracking-details-strip">
                                    <span>{{ OrderDetails?.origin_city || marketplaceFlow?.city || 'Origin' }}</span>
                                    <span class="tracking-store-name"><i
                                            class="fas fa-store me-1"></i>{{OrderDetails?.store_name}}</span>
                                    <span>{{ OrderDetails?.city }}</span>
                                </div>

                                <div class="row d-flex justify-content-center">
                                    <div class="track_content track-progress-shell">
                                        <div class="left_box circle track-point">
                                            <div class="icon">
                                                <i class="fas fa-map-pin"></i>
                                            </div>
                                        </div>
                                        <div class="middle_box track-progress-line">
                                            <div class="progress" [style.width.%]="progressWidth"></div>
                                        </div>
                                        <div class="right_box circle track-point">
                                            <div class="icon">
                                                <i class="fas fa-truck"></i>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-lg-4">
                            <div class="track-status-panel h-100">
                                <div class="track-status-panel__label">Current Status</div>
                                <div class="track-status-panel__icon">
                                    <i class="fas fa-route"></i>
                                </div>
                                <div class="track-status-holder w-100">
                                    <input class="text-wrap track-status-input" type="button" value=""
                                        id="deliverstatus" />
                                </div>
                                <div class="track-status-note">
                                    Latest shipment milestone synced with your tracking timeline.
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </article>

            <aside class="track-promo-side" *ngIf="scrapedProducts.length > 0">
                <!-- Advertisement sidebar only shows when products available -->
                <div class="track-promo-shell">
                    <div class="track-promo-marquee">
                        <div class="track-promo-track" [class.track-promo-scroll]="marqueeProducts.length > 2">
                            <a *ngFor="let product of marqueeProducts" class="track-promo-item" [href]="product.url"
                                target="_blank" rel="noopener noreferrer">
                                <div class="track-promo-item__brand">
                                    <img [src]="this.njourImageUrl || 'assets/img/njour-logo.png'" alt="Njour Logo"
                                        class="track-promo-item__brand-logo">
                                </div>
                                <div class="track-promo-item__visual" *ngIf="product.imageUrl">
                                    <img [src]="product.imageUrl" [alt]="product.title" class="track-promo-item__image">
                                </div>
                                <div class="track-promo-item__content">
                                    <div class="track-promo-item__meta">
                                        <span class="track-promo-item__taxonomy">{{ product.taxonomy_title }}</span>
                                    </div>
                                    <h3 class="track-promo-item__title">{{ product.title }}</h3>
                                    <div class="track-promo-item__stats" *ngIf="product.sales || product.stock > 0">
                                        <span class="track-promo-item__sales" *ngIf="product.sales">{{ product.sales
                                            }}</span>
                                        <span class="track-promo-item__stock" *ngIf="product.stock > 0">Stock: {{
                                            product.stock }}</span>
                                    </div>
                                    <div class="track-promo-item__bottom">
                                        <div class="track-promo-item__pricing">
                                            <span class="track-promo-item__price">{{ product.price }}</span>
                                            <span class="track-promo-item__mrp">{{ product.originalPrice }}</span>
                                            <span class="track-promo-item__discount">{{ product.discount }}</span>
                                        </div>
                                        <div class="track-promo-item__cta">
                                            <span class="track-promo-stars"
                                                [attr.aria-label]="(product.rating | number:'1.1-1') + ' out of 5 stars'">
                                                <span class="track-promo-stars__base">★★★★★</span>
                                                <span class="track-promo-stars__fill"
                                                    [style.width.%]="getRatingWidth(product.rating)">★★★★★</span>
                                            </span>
                                            <span class="track-promo-item__rating">{{ product.rating | number:'1.1-1'
                                                }}</span>
                                        </div>
                                    </div>
                                </div>
                            </a>
                        </div>
                    </div>
                </div>
            </aside>
        </div>
    </div>
    <div class="report_field mt-2">
        <div class="track-page-shell mb-4">
            <article class="card border shadow rounded-4 overflow-hidden">
                <header class="card-header bg-white border-bottom px-3 py-2">
                    <div class="d-flex align-items-center justify-content-between flex-wrap">
                        <div>
                            <div class="text-uppercase small fw-semibold text-muted mb-1 mt-1">Shipment Tracking</div>
                            <h5 class="mb-0 fw-bold text-dark">Tracking History</h5>
                        </div>

                    </div>
                </header>

                <div class="card-body p-2">
                    <ng-container *ngIf="actualTrackingDetails.length > 0 || trackingDetails.length > 0;">
                        <div class="row g-2 mb-3">

                            <!-- Current Milestone -->
                            <div class="col-lg-5">
                                <div class="border rounded-3 p-2 h-100 bg-light">
                                    <div class="text-uppercase small fw-semibold text-muted">
                                        Current Milestone
                                    </div>

                                    <h6 class="fw-bold text-dark mb-0">
                                        <ng-container *ngIf="actualTrackingDetails.length > 0; else noAcTracking">
                                            Your Order Is {{ latestTracking?.activity || latestTracking?.status ||
                                            actualTrackingDetails[0]?.activity || actualTrackingDetails[0]?.status }}
                                        </ng-container>

                                        <ng-template #noAcTracking>
                                            Your Order Is {{ trackingDetails[0]?.status }}
                                        </ng-template>
                                    </h6>
                                </div>
                            </div>

                            <!-- Origin -->
                            <div class="col-lg-2">
                                <div class="border rounded-3 p-2 h-100 bg-white">
                                    <div class="text-uppercase small fw-semibold text-muted">
                                        Origin
                                    </div>
                                    <div class="fw-bold text-dark">
                                        {{ OrderDetails?.origin_city || marketplaceFlow?.city || 'N/A' }}
                                    </div>
                                </div>
                            </div>

                            <!-- Store -->
                            <div class="col-lg-2">
                                <div class="border rounded-3 p-2 h-100 bg-white">
                                    <div class="text-uppercase small fw-semibold text-muted">
                                        Store
                                    </div>
                                    <div class="fw-bold text-success">
                                        <i class="fas fa-store me-1"></i>
                                        {{ OrderDetails?.store_name }}
                                    </div>
                                </div>
                            </div>

                            <!-- Destination -->
                            <div class="col-lg-3">
                                <div class="border rounded-3 p-2 h-100 bg-white">
                                    <div class="text-uppercase small fw-semibold text-muted">
                                        Destination
                                    </div>
                                    <div class="fw-bold text-dark">
                                        {{ OrderDetails?.city }}
                                    </div>
                                </div>
                            </div>

                        </div>

                        <div>
                            <ng-container
                                *ngIf="trackingDetails.length > 0 && trackingDetails[0].status === 'Order Delivered'; else normalTracking">
                                <div class="d-flex gap-3 align-items-start"
                                    *ngIf="actualTrackingDetails && actualTrackingDetails.length > 1">
                                    <div class="position-relative flex-shrink-0" style="width: 18px; min-height: 56px;">
                                        <div
                                            class="position-absolute top-0 bottom-0 start-50 translate-middle-x border-start border-2 border-success">
                                        </div>
                                        <span
                                            class="position-absolute top-0 start-50 translate-middle bg-white border border-2 border-success rounded-circle"
                                            style="width: 14px; height: 14px;"></span>
                                    </div>
                                    <div class="flex-grow-1 pt-1">
                                        <div class="d-flex justify-content-between flex-wrap gap-2">
                                            <h6 class="mb-1 fw-semibold text-dark">Order Delivered</h6>
                                            <small class="text-muted">
                                                {{ trackingDetails[0]?.date | date:'dd MMM yyyy' }}
                                                {{ trackingDetails[0]?.time || (trackingDetails[0]?.date | date:'HH:mm')
                                                }}
                                            </small>
                                        </div>
                                        <div *ngIf="actualTrackingDetails && actualTrackingDetails.length > 1"
                                            class="mt-2">
                                            <button class="btn btn-outline-dark btn-sm rounded-pill px-3" mat-button
                                                (click)="toggleDetails()">
                                                {{ isDisplayTrackingDetails ? ' View Details - ' : ' View Details + '}}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </ng-container>

                            <ng-template #normalTracking>
                                <ng-container *ngIf="actualTrackingDetails.length > 0; else noLink">
                                    <div class="d-flex gap-3 align-items-start"
                                        *ngIf="actualTrackingDetails && actualTrackingDetails.length > 0">
                                        <div class="position-relative flex-shrink-0"
                                            style="width: 18px; min-height: 56px;">
                                            <div
                                                class="position-absolute top-0 bottom-0 start-50 translate-middle-x border-start border-2 border-success">
                                            </div>
                                            <span
                                                class="position-absolute top-0 start-50 translate-middle bg-white border border-2 border-success rounded-circle"
                                                style="width: 14px; height: 14px;"></span>
                                        </div>
                                        <div class="flex-grow-1 pt-1">
                                            <div class="d-flex justify-content-between flex-wrap gap-2">
                                                <h6 class="mb-1 fw-semibold text-dark">{{
                                                    latestTracking?.status }}</h6>
                                                <small class="text-muted">
                                                    {{ latestTracking?.date | date :'dd MMM YYYY' }}
                                                    {{ latestTracking?.time || (latestTracking?.date
                                                    | date:'HH:mm') }}
                                                </small>
                                            </div>
                                            <p class="text-muted mb-0">Location: {{
                                                latestTracking?.location | replaceStrings }}</p>
                                            <div *ngIf="actualTrackingDetails && actualTrackingDetails.length > 1"
                                                class="mt-2">
                                                <button class="btn btn-outline-dark btn-sm rounded-pill px-3" mat-button
                                                    (click)="toggleDetails()">
                                                    {{ isDisplayTrackingDetails ? ' View Details - ' : ' View Details +
                                                    '}}
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </ng-container>
                            </ng-template>

                            <ng-container *ngFor="let trackingDetail of trackingDetails; let i = index">
                                <ng-container
                                    *ngIf=" (trackingDetail.status !== 'Order Delivered') || (actualTrackingDetails.length === 0 && trackingDetail.status === 'Order Delivered' )  ">
                                    <div class="d-flex gap-3 align-items-start">
                                        <div class="position-relative flex-shrink-0"
                                            style="width: 18px; min-height: 48px;">
                                            <div
                                                class="position-absolute top-0 bottom-0 start-50 translate-middle-x border-start border-2 border-success">
                                            </div>
                                            <span
                                                class="position-absolute top-0 start-50 translate-middle bg-white border border-2 border-success rounded-circle"
                                                style="width: 14px; height: 14px;"></span>
                                        </div>
                                        <div class="flex-grow-1 pt-1">
                                            <div class="d-flex justify-content-between flex-wrap gap-2">
                                                <h6 class="mb-1 fw-semibold text-dark">{{ trackingDetail.status }}</h6>
                                                <small class="text-muted">
                                                    <ng-container
                                                        *ngIf="actualTrackingDetails.length > 0 && trackingDetail.status?.includes('Dispatched'); else dateUpdation">
                                                        {{
                                                        DispatchDate(actualTrackingDetails[actualTrackingDetails.length
                                                        - 1].date) | date :'dd MMM YYYY HH:mm ' }}
                                                    </ng-container>
                                                    <ng-template #dateUpdation>
                                                        {{ trackingDetail.date | date :'dd MMM YYYY HH:mm ' }}
                                                    </ng-template>
                                                </small>
                                            </div>
                                        </div>
                                    </div>
                                </ng-container>
                            </ng-container>
                        </div>
                    </ng-container>
                </div>

                <ng-container *ngIf="isDisplayTrackingDetails">
                    <button type="button" id="gotoTop" style="border: none;"></button>
                    <ng-container *ngTemplateOutlet="rowDetailsTemplate "></ng-container>
                </ng-container>
            </article>
        </div>
    </div>
</div>

<ng-template #rowDetailsTemplate1>
    <ng-container *ngFor="let trackingDetail of actualTrackingDetails; let i = index">
        <ng-container *ngIf="i !== 0  ">
            <li class="green">
                <br />
                <p class="description "> {{ trackingDetail?.activity }} </p>
                <p class="green "> Location: {{ trackingDetail?.location | replaceStrings }}</p>
                <p class="green "> {{ trackingDetail?.date | date :'dd MMM YYYY HH:mm ' }}
                </p>
            </li>
        </ng-container></ng-container>
</ng-template>

<ng-template #rowDetailsTemplate>
    <div class="report_field mt-0">
        <div class="bg-white border rounded-4 shadow-sm p-4 w-100">
            <h6 class="fw-bold text-dark mb-4 text-uppercase small tracking-history-title">Tracking History</h6>
            <div class="tracking-timeline">
                <div *ngFor="let trackingDetail of actualTrackingDetails; let i = index; let last = last"
                    class="timeline-item" [class.last-item]="last">
                    <div class="timeline-marker">
                        <div class="timeline-dot" [class.active]="i === 0"></div>
                        <div *ngIf="!last" class="timeline-line"></div>
                    </div>
                    <div class="timeline-card">
                        <div class="timeline-header">
                            <span class="timeline-status">{{ trackingDetail.status }}</span>
                            <span class="timeline-time">{{ trackingDetail.date | date :'dd MMM YYYY' }}
                                {{trackingDetail?.time}}</span>
                        </div>
                        <div class="timeline-location">
                            <i class="fas fa-map-marker-alt"></i>
                            {{ trackingDetail.location | replaceStrings }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-template>

<div *ngIf="noOrderFound">
    <div class="track-page-shell track-no-order my-4">
        <div class="card border-0 shadow-sm rounded-4 bg-white p-4 mx-auto text-center" style="max-width: 620px;">
            <div class="d-inline-flex align-items-center justify-content-center bg-warning-subtle text-warning-dark rounded-circle mx-auto mb-3"
                style="width: 56px; height: 56px;">
                <i class="fas fa-exclamation-triangle fs-3"></i>
            </div>
            <h5 class="fw-bold text-dark mb-2">No Order Details Found</h5>
            <p class="text-muted small mb-3">
                We couldn't find any tracking information matching the entered number. Please verify the order or
                tracking number and try again, or reach out to our customer support.
            </p>
            <div class="d-flex justify-content-center gap-2">
                <a routerLink="/contact"
                    class="btn btn-dark btn-sm rounded-pill px-4 py-2 d-inline-flex align-items-center gap-2 text-decoration-none">
                    <i class="fas fa-headset"></i>
                    <span>Contact Support</span>
                </a>
            </div>
        </div>
    </div>

    <!-- Product Advertisement Horizontal Smooth Auto-Scrolling Marquee -->
    <div class="track-page-shell py-4" *ngIf="scrapedProducts.length > 0">
        <div class="track-promo-marquee-horizontal">
            <div class="track-promo-track-horizontal" [class.track-promo-scroll-infinite]="marqueeProducts.length > 1">
                <a *ngFor="let product of marqueeProducts" class="track-promo-item-horizontal" [href]="product.url"
                    target="_blank" rel="noopener noreferrer">
                    <div class="track-promo-item__brand">
                        <img [src]="this.njourImageUrl || 'assets/img/njour-logo.png'" alt="Njour Logo"
                            class="track-promo-item__brand-logo">
                    </div>
                    <div class="track-promo-item__visual" *ngIf="product.imageUrl">
                        <img [src]="product.imageUrl" [alt]="product.title" class="track-promo-item__image">
                    </div>
                    <div class="track-promo-item__content">
                        <div class="track-promo-item__meta">
                            <span class="track-promo-item__taxonomy">{{ product.taxonomy_title }}</span>
                        </div>
                        <h3 class="track-promo-item__title">{{ product.title }}</h3>
                        <div class="track-promo-item__stats" *ngIf="product.sales || product.stock > 0">
                            <span class="track-promo-item__sales" *ngIf="product.sales">{{ product.sales }}</span>
                            <span class="track-promo-item__stock" *ngIf="product.stock > 0">Stock: {{ product.stock
                                }}</span>
                        </div>
                        <div class="track-promo-item__bottom">
                            <div class="track-promo-item__pricing">
                                <span class="track-promo-item__price">{{ product.price }}</span>
                                <span class="track-promo-item__mrp" *ngIf="product.originalPrice">{{
                                    product.originalPrice }}</span>
                                <span class="track-promo-item__discount" *ngIf="product.discount">{{ product.discount
                                    }}</span>
                            </div>
                            <div class="track-promo-item__cta">
                                <span class="track-promo-stars"
                                    [attr.aria-label]="(product.rating | number:'1.1-1') + ' out of 5 stars'">
                                    <span class="track-promo-stars__base">★★★★★</span>
                                    <span class="track-promo-stars__fill"
                                        [style.width.%]="getRatingWidth(product.rating)">★★★★★</span>
                                </span>
                                <span class="track-promo-item__rating">{{ product.rating | number:'1.1-1' }}</span>
                            </div>
                        </div>
                    </div>
                </a>
            </div>
        </div>
    </div>
</div>

<!-- Floating Contact Us Action Button -->
<a routerLink="/contact" class="track-floating-contact-btn shadow-lg" title="Need Help? Contact Us">
    <i class="fas fa-headset"></i>
    <span class="floating-btn-text">Contact Us</span>
</a>

<div *ngIf="canUpdateTracking && showUpdateTrackingModal" class="track-update-modal-backdrop"
    (click)="closeUpdateTrackingModal()">
    <div class="track-update-modal" role="dialog" aria-labelledby="updateTrackingTitle" aria-modal="true"
        (click)="$event.stopPropagation()">
        <div class="track-update-modal__header">
            <div>
                <div class="track-update-modal__kicker">Shipment Update</div>
                <h5 id="updateTrackingTitle" class="track-update-modal__title mb-0">Update Shipping &amp; Tracking
                    Information</h5>
            </div>
            <button type="button" class="track-update-modal__close" aria-label="Close"
                (click)="closeUpdateTrackingModal()" [disabled]="isUpdatingTracking">
                <i class="fas fa-times"></i>
            </button>
        </div>

        <form [formGroup]="updateTrackingForm" (ngSubmit)="submitUpdateTracking()" class="track-update-modal__body">
            <div class="mb-3">
                <label for="shippingBy" class="form-label track-update-modal__label">Shipping By</label>
                <select id="shippingBy" class="form-select track-update-modal__input" formControlName="shippingBy">
                    <option value="" disabled>Select a carrier</option>
                    <option *ngFor="let carrier of carrierCompanyList" [value]="carrier">{{ carrier }}</option>
                </select>
                <div class="track-update-modal__error"
                    *ngIf="updateTrackingForm.get('shippingBy')?.touched && updateTrackingForm.get('shippingBy')?.hasError('required')">
                    Shipping By is required.
                </div>
            </div>

            <div class="mb-2">
                <label for="trackingNumber" class="form-label track-update-modal__label">Tracking Number</label>
                <input id="trackingNumber" type="text" class="form-control track-update-modal__input"
                    formControlName="trackingNumber" placeholder="Enter tracking number">
                <div class="track-update-modal__error"
                    *ngIf="updateTrackingForm.get('trackingNumber')?.touched && updateTrackingForm.get('trackingNumber')?.hasError('required')">
                    Tracking Number is required.
                </div>
            </div>

            <div class="track-update-modal__footer">
                <button type="button" class="btn btn-light rounded-pill px-4" (click)="closeUpdateTrackingModal()"
                    [disabled]="isUpdatingTracking">
                    Cancel
                </button>
                <button type="submit" class="btn btn-primary rounded-pill px-4"
                    [disabled]="isUpdatingTracking || updateTrackingForm.invalid">
                    <span *ngIf="!isUpdatingTracking">Save Changes</span>
                    <span *ngIf="isUpdatingTracking">Saving...</span>
                </button>
            </div>
        </form>
    </div>
</div>